import { useDyteMeeting } from "@dytesdk/react-web-core";
import { Mic, MicOff, Video, VideoOff } from "lucide-react";

interface ParticipantsPanelProps {
  show: boolean;
  isMicOn: boolean;
  isVideoOn: boolean;
  onClose: () => void;
}

export default function ParticipantsPanel({
  show,
  isMicOn,
  isVideoOn,
}: ParticipantsPanelProps) {
  const { meeting } = useDyteMeeting();
  const participants = meeting?.participants.active.toArray() || [];
  const localParticipant = meeting?.self;

  if (!show) return null;
  return (
    <div className="absolute left-4 top-40 z-30 w-64 rounded-lg bg-black/80 p-4 text-white backdrop-blur-sm">
      <h3 className="mb-3 text-sm font-medium">
        Participants ({participants.length})
      </h3>
      <div className="space-y-2">
        <div className="flex items-center gap-3 rounded p-2 hover:bg-white/10">
          <div className="flex size-8 items-center justify-center rounded-full bg-primary">
            <span className="text-sm text-white">
              {localParticipant.name.charAt(0)}
            </span>
          </div>
          <div className="flex-1">
            <div className="w-full text-sm truncate">
              {localParticipant.name} (You)
            </div>
            <div className="w-full text-xs text-white/70">Mentee</div>
          </div>
          <div className="flex items-center gap-1">
            {isMicOn ? (
              <Mic className="size-3" />
            ) : (
              <MicOff className="size-3 text-red-400" />
            )}
            {isVideoOn ? (
              <Video className="size-3" />
            ) : (
              <VideoOff className="size-3 text-red-400" />
            )}
          </div>
        </div>
        <div className="flex items-center gap-3 rounded p-2 hover:bg-white/10">
          <div className="size-8 overflow-hidden rounded-full">
            <img
              src="/60695538-3ffa-4211-9645-68b0244a31fe.png"
              alt="Jay"
              className="size-full object-cover"
            />
          </div>
          <div className="flex-1">
            <div className="text-sm">{participants[0].name}</div>
            <div className="text-xs text-white/70">Mentor</div>
          </div>
          <div className="flex items-center gap-1">
            <Mic className="size-3" />
            <Video className="size-3" />
          </div>
        </div>
      </div>
    </div>
  );
}
